import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
import { defaultTheme } from '@drone-js/theme';
export { defaultTheme } from '@drone-js/theme';
import { mergeThemeExperiment } from './ThemeExperiment.js';

var ThemeContext = /*#__PURE__*/React.createContext(defaultTheme);
var useThemeContext = function useThemeContext() {
  return React.useContext(ThemeContext);
};
var ThemeContextProvider = /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children,
    deprecateInaccessibleColor = _ref.deprecateInaccessibleColor,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? defaultTheme : _ref$value;
  var _React$useMemo = React.useMemo(function () {
      return mergeThemeExperiment(value, [['deprecateInaccessibleColor', deprecateInaccessibleColor]]);
    }, [value, deprecateInaccessibleColor]),
    _React$useMemo2 = _slicedToArray(_React$useMemo, 2),
    theme = _React$useMemo2[0],
    classNames = _React$useMemo2[1];
  var previousClassNames = React.useRef([]);
  React.useEffect(function () {
    var toAddClasses = classNames.split(' ');
    var toRemoveClasses = previousClassNames.current.filter(function (previousClassName) {
      return !toAddClasses.includes(previousClassName);
    });
    toRemoveClasses.forEach(function (className) {
      document.body.classList.remove(className);
    });
    toAddClasses.forEach(function (className) {
      document.body.classList.add(className);
    });
    previousClassNames.current = toAddClasses;
  }, [classNames]);
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: theme
  }, children);
});
ThemeContextProvider.displayName = 'ThemeContextProvider';

export { ThemeContextProvider, useThemeContext };
//# sourceMappingURL=Theme.js.map
